import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

export default function useAutoLogout(timeoutMinutes = 15) {
  const navigate = useNavigate();
  const timer = useRef(null);

  useEffect(() => {
    const keepSignedIn = localStorage.getItem("keep_signed_in") === "true";
    if (keepSignedIn) return;

    const reset = () => {
      clearTimeout(timer.current);
      timer.current = setTimeout(() => {
        localStorage.clear();
        sessionStorage.clear();
        navigate("/");
      }, timeoutMinutes * 60 * 1000);
    };

    const events = ["mousemove", "keydown", "click", "scroll", "touchstart"];
    events.forEach(e => window.addEventListener(e, reset));
    reset();

    return () => {
      clearTimeout(timer.current);
      events.forEach(e => window.removeEventListener(e, reset));
    };
  }, [navigate, timeoutMinutes]);
}
